import styled from 'styled-components';
import { FormField, HorizontalInput } from 'ui/formField';
import { GhostButton } from 'ui/button';
import { InputText } from 'ui/inputs';
import { body2Medium, caption, colors, spacing, WebLink } from 'ui/theme';

export const StyledLink = styled(WebLink)`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
  word-break: break-all;

  svg {
    flex-shrink: 0;
  }
`;

export const EditableLabel = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
  width: 100%;
  word-break: break-word;
`;

export const LabelWrapper = styled.div`
  input {
    width: 100%;
  }
`;

export const RestrictionText = styled.span`
  ${caption}
  color: ${colors.textSecondary};
`;

export const LabelRow = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const InputFieldRow = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const StyledInputText = styled(InputText)`
  flex: 1;
`;

export const StyledGhostButton = styled(GhostButton)`
  padding: ${spacing.half};
`;

export const StyledFormField = styled(FormField)`
  ${HorizontalInput} {
    width: 0;
    padding: ${spacing.single};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const RadioWrapper = styled.div`
  ${body2Medium}
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;

export const InputTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
  margin-left: ${spacing.double};
`;

export const HelpText = styled.span`
  ${caption}
  color: ${colors.textSecondary};
  white-space: normal;
`;

export const ErrorText = styled(HelpText)`
  color: ${colors.textDestructive};
  white-space: break-spaces;
`;
